import React, { useState, useEffect } from 'react';
import { TreePine, Volume2, Wifi, Keyboard } from 'lucide-react';

const SHORTCUTS = [
  { key: '1', action: 'About' },
  { key: '2', action: 'Experience' },
  { key: '3', action: 'Projects' },
  { key: '4', action: 'Contact' },
  { key: '5', action: 'Snake' },
  { key: '6', action: 'TypeSpeed' },
];

const Taskbar = ({ windows, openWindows, minimizedWindows, onWindowClick, onStartClick, startOpen }) => {
  const [time, setTime] = useState(new Date());
  const [showShortcuts, setShowShortcuts] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = () => time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const modKey = isMac ? '⌘' : 'Ctrl';

  return (
    <div className="taskbar">
      <button className={`start-button ${startOpen ? 'active' : ''}`} onClick={onStartClick}>
        <span className="start-icon">
          <TreePine size={18} strokeWidth={1.5} />
        </span>
        <span>Start</span>
      </button>

      <div className="taskbar-windows">
        {windows.filter(w => openWindows.includes(w.id)).map(w => (
          <button
            key={w.id}
            className={`taskbar-window-btn ${minimizedWindows.includes(w.id) ? 'minimized' : 'active'}`}
            onClick={() => onWindowClick(w.id)}
          >
            {w.Icon && <w.Icon size={14} strokeWidth={1.5} />}
            <span>{w.title}</span>
          </button>
        ))}
      </div>

      <div className="taskbar-tray">
        <div
          className="tray-shortcuts"
          onMouseEnter={() => setShowShortcuts(true)}
          onMouseLeave={() => setShowShortcuts(false)}
        >
          <span className="tray-icon tray-icon-interactive">
            <Keyboard size={14} strokeWidth={1.5} />
          </span>
          {showShortcuts && (
            <div className="shortcuts-tooltip">
              <div className="shortcuts-title">Keyboard Shortcuts</div>
              {SHORTCUTS.map(s => (
                <div key={s.key} className="shortcut-item">
                  <span className="shortcut-key">{modKey}+{s.key}</span>
                  <span className="shortcut-action">{s.action}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <span className="tray-icon"><Volume2 size={14} strokeWidth={1.5} /></span>
        <span className="tray-icon"><Wifi size={14} strokeWidth={1.5} /></span>
        <span className="tray-time">{formatTime()}</span>
      </div>
    </div>
  );
};

export default Taskbar;
